import { createAsyncThunk } from '@reduxjs/toolkit';
import MajorCategoriesService from './majorCategories_service';
import { 
  getMajorCategoriesStart, 
  getMajorCategoriesSuccess, 
  getMajorCategoriesFailed 
} from './majorCategories_slices';
import { toast } from 'react-toastify';

export const getAllMajorCategories = createAsyncThunk(
  'majorCategories/getAllMajorCategories',
  async (payload, { dispatch }) => {
    try {
      dispatch(getMajorCategoriesStart());
      const response = await MajorCategoriesService.getAllMajorCategories(payload);
      dispatch(getMajorCategoriesSuccess(response));
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Failed to fetch major categories';
      toast.error(errorMessage);
      dispatch(getMajorCategoriesFailed(errorMessage));
      throw error;
    }
  }
);
